import React from "react";
import { notify } from "@/shared/utils/notify";
import { saucesWarehousesService } from "../../../../shared/services";

export const useAssignSauceWharehouse = () => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const assignSauceWharehouse = async ({
    warehouseId,
    sauceId,
  }: {
    warehouseId: number;
    sauceId: number;
  }) => {
    if (loading) return;
    setLoading(true);

    try {
      // Buscar el producto en la bodega
      const { data } = await saucesWarehousesService.find({
        query: {
          warehouse_id: +warehouseId,
          sauce_id: +sauceId,
        },
      });

      if (data && data.length === 0) {
        // Si el producto no está en la bodega, lo creamos
        await saucesWarehousesService.create({
          warehouse_id: +warehouseId,
          sauce_id: +sauceId,
          status: "active",  // Asignar estado 'active' directamente al crear
        });
        notify.success("Se ha asignado exitosamente el producto a la bodega", 2);
      } else {
        // Si el producto está en la bodega, actualizamos su estado a 'active'
        await saucesWarehousesService.patch(data[0].id, { status: "active" });
        notify.success("Se ha actualizado el producto a la bodega", 2);
      }
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const removeSauceWharehouse = async (
    warehouseId: number,
    sauceId: number
  ) => {
    if (loading) return;
    setLoading(true);

    try {
      // Buscar el producto en la bodega
      const { data } = await saucesWarehousesService.find({
        query: {
          warehouse_id: +warehouseId,
          sauce_id: +sauceId,
        },
      });

      if (data && data.length > 0) {
        // Si el producto está en la bodega, actualizamos su estado a 'inactive'
        await saucesWarehousesService.patch(data[0].id, { status: "inactive" });
        notify.success("Se ha removido exitosamente el producto de la bodega", 2);
      } else {
        // El producto no está en la bodega, mostrar mensaje adecuado
        notify.warning("El producto no está en la bodega", 2);
      }
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    assignSauceWharehouse,
    removeSauceWharehouse,
  };
};
